// import { useRef } from "react";

// import Banner from "./Banner";
// import JobInformation from "./JobInformation";
// import FormSection from "./FormSection";

// const JobDetails = () => {
//   const applyFormRef = useRef(null);

//   return (
//     <>
//       <div className="bg-white text-gray-800">
//         <Banner
//           config={{
//             applyFormRef,
//             title: "UI/UX Designer",
//           }}
//         />

//         <div className="bg-white px-6 md:px-16 py-12">
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
//             <div className="lg:col-span-2 space-y-12">
//               <div>
//                 <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
//                   Job Summary
//                 </h2>

//                 <p className="text-[#212129] text-[18px] leading-8 mb-6">
//                   We seek a passionate and creative UI/UX Intern to join our
//                   team. This internship is an excellent opportunity for students
//                   or recent graduates to gain hands-on experience, work on real
//                   projects, and build a professional portfolio in a
//                   collaborative and creative environment.
//                 </p>
//               </div>

//               <div>
//                 <h3 className="text-[20px] font-semibold text-green-600 mb-1">
//                   Key Responsibilities
//                 </h3>
//                 <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

//                 <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
//                   <li>
//                     Assist in designing graphics for social media posts,
//                     banners, brochures, and marketing materials.
//                   </li>
//                   <li>
//                     Support senior designers in day-to-day creative tasks.
//                   </li>
//                   <li>
//                     Work on branding elements like logos, business cards, and
//                     digital assets.
//                   </li>
//                   <li>
//                     Take part in brainstorming sessions and contribute creative
//                     ideas.
//                   </li>
//                   <li>
//                     Ensure design consistency and alignment with brand
//                     guidelines.
//                   </li>
//                   <li>
//                     Collaborate with content writers, marketers, and developers
//                     to execute creative projects.
//                   </li>
//                   <li>Adapt and revise existing designs as per feedback.</li>
//                 </ul>
//               </div>

//               <div>
//                 <h3 className="text-[20px] font-semibold text-green-600 mb-1">
//                   Required Skills
//                 </h3>
//                 <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

//                 <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
//                   <li>
//                     Proficiency in Adobe Creative Suite (Photoshop, Illustrator,
//                     Premiere Pro, After Effects); knowledge of Figma is a plus.
//                   </li>
//                   <li>
//                     Basic understanding of design principles: layout, color,
//                     typography, and visual hierarchy.
//                   </li>
//                   <li>Creative mindset with attention to detail.</li>
//                   <li>Good communication skills and willingness to learn.</li>
//                   <li>
//                     Ability to work under deadlines and take constructive
//                     feedback positively.
//                   </li>
//                   <li>
//                     Portfolio (academic, freelance, or personal projects)
//                     showcasing design skills.
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             <JobInformation />
//           </div>
//         </div>

//       </div>

//       <FormSection applyFormRef={applyFormRef} />
//     </>
//   );
// };

// export default JobDetails;

import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        <Banner
          config={{
            applyFormRef,
            title: "Graphic Designer",
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are looking for a creative and talented Graphic Designer
                  to join our team. The ideal candidate should have a strong
                  eye for visual design, branding, and digital creativity. You
                  will work closely with marketing, content, and development
                  teams to create engaging designs that strengthen our brand
                  presence across digital and print platforms.
                </p>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Design creative graphics for social media, websites,
                    advertisements, email campaigns, and marketing materials.
                  </li>
                  <li>
                    Develop branding assets including logos, brochures,
                    business cards, presentations, and promotional materials.
                  </li>
                  <li>
                    Collaborate with marketing and content teams to create
                    visually engaging campaigns.
                  </li>
                  <li>
                    Create and edit images, illustrations, infographics, and
                    visual content.
                  </li>
                  <li>
                    Ensure all designs are aligned with brand guidelines and
                    maintain visual consistency.
                  </li>
                  <li>
                    Work on multiple projects simultaneously while meeting
                    deadlines.
                  </li>
                  <li>
                    Stay updated with industry trends and incorporate innovative
                    design concepts into projects.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Required Skills
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Proficiency in Adobe Creative Suite (Photoshop,
                    Illustrator, InDesign).
                  </li>
                  <li>
                    Knowledge of Figma, Canva, Premiere Pro, or After Effects
                    is an added advantage.
                  </li>
                  <li>
                    Strong understanding of typography, color theory, layout,
                    and visual hierarchy.
                  </li>
                  <li>
                    Excellent creativity and attention to detail.
                  </li>
                  <li>
                    Good communication and teamwork skills.
                  </li>
                  <li>
                    Ability to handle multiple projects and meet deadlines.
                  </li>
                  <li>
                    A strong portfolio showcasing graphic design and branding
                    work.
                  </li>
                </ul>
              </div>

            </div>

            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
